<template>
  <!-- 个人工队-工种报价详情页 -->
  <div class="talents">
    <EmptyData :type="state" v-if="state != 1" style="margin-top: 10px">
      当前数据已{{ state == 2 ? "下架" : "删除" }}，点击
      <a @click="handleBack">返回列表</a> 继续浏览吧~
    </EmptyData>

    <div
      class="talents_details"
      v-loading="loading"
      element-loading-background="rgba(255, 255, 255, 1)"
      v-if="state == 1"
    >
      <!-- 头部 -->
      <div class="talents_details_content">
        <div class="talents_details_content_left">
          <div
            style="
              font-size: 18px;
              font-weight: bold;
              color: #333;
              text-align: center;
              background: #fff;
              margin-top: 10px;
              padding-top: 20px
            "
          >
            {{YJinfo.categoryName.split("-").length>=3 ? YJinfo.categoryName.split("-")[2] : YJinfo.categoryName.split("-")[ YJinfo.categoryName.split("-").length-1]}}
          </div>
          <div class="talents_details_content_left_titleBox">
            <div class="left_box">
              <el-row :gutter="24" class="itemRow" style="align-items: start">
                <el-col :span="8">
                  <div class="item_text" style="margin-bottom: 5px;display:flex">
                    <span
                      ><img
                        src="@/assets/TeamOfferDetail/gclx.png"
                      />工程类型：</span
                    >
                    <div @mouseenter="handleShowTooltip($event)">
                      <el-tooltip popper-class="popperCustoms" :visible-arrow="false" :disabled="showTooltip"  placement="bottom"  class="single_hide" effect="light">
                        <span class="item_data color3" style="vertical-align:top;display:inline-block;width: 265px;">
                          {{YJinfo.categoryName ? YJinfo.categoryName : ""}}</span>
                        <div slot="content"  style="color: #666" >{{YJinfo.categoryName}}</div>
                      </el-tooltip>
                    </div>
                  </div>
                </el-col>
               <el-col :span="8">
                  <div class="item_text" style="display:flex">
                    <span><img src="@/assets/TeamOfferDetail/gzmc.png">工种名称：</span>
                    <div @mouseenter="handleShowTooltip($event)">
                      <el-tooltip popper-class="popperCustoms" :visible-arrow="false" :disabled="showTooltip"  placement="bottom"  class="single_hide" effect="light">
                        <span class="item_data color3" style="vertical-align:top;display:inline-block;width: 265px;">
                          {{YJinfo.categoryName.split("-").length>=3 ? YJinfo.categoryName.split("-")[2] : YJinfo.categoryName.split("-")[ YJinfo.categoryName.split("-").length-1]}}</span>
                        <div slot="content"  style="color: #666" >{{YJinfo.categoryName.split("-").length>=3 ? YJinfo.categoryName.split("-")[2] : YJinfo.categoryName.split("-")[ YJinfo.categoryName.split("-").length-1]}}</div>
                      </el-tooltip>
                    </div>
                  </div>
               </el-col> 
               <el-col :span="8" >
                  <div class="item_text single_hide" style="display:flex">
                    <span class="color6"><img src="@/assets/TeamOfferDetail/bjgd.png">报价工队：</span>
                    <div @mouseenter="handleShowTooltip($event)">
                      <el-tooltip popper-class="popperCustoms" :visible-arrow="false" :disabled="showTooltip"  placement="bottom" class="single_hide" effect="light">
                        <div class=" color3 single_hide" style="color: #333;max-width:235px">{{ YJinfo.teamName ? YJinfo.teamName : "/"}}</div>
                        <div slot="content"  style="color: #666;">{{YJinfo.teamName ? YJinfo.teamName : "/"}}</div>
                      </el-tooltip>
                    </div>
                  </div>
                </el-col>   
              </el-row>       
              <el-row :gutter="24" class="itemRow">
                <el-col :span="8">
                  <div class="item_text single_hide" style="display:flex">
                    <span class="item_icon">
                      <img src="@/assets/TeamOfferDetail/szdq.png" alt="" />
                    </span>
                    <span class="color6">工作区域：</span>
                    <div @mouseenter="handleShowTooltip($event)">
                      <el-tooltip popper-class="popperCustoms" :visible-arrow="false" :disabled="showTooltip"  placement="bottom" class="single_hide" effect="light">
                        <div class=" color3 single_hide" style="color: #333;max-width:232px">{{ YJinfo.provinceName}}{{ YJinfo.cityName}}{{ YJinfo.areaName}}</div>
                        <div slot="content"  style="color: #666;">{{ YJinfo.provinceName}}{{ YJinfo.cityName}}{{ YJinfo.areaName}}</div>
                      </el-tooltip>
                    </div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="item_text single_hide" style="display:flex">
                    <span class="item_icon">
                      <img src="@/assets/TeamOfferDetail/szdq.png" alt="" />
                    </span>
                    <span class="color6">详细地址：</span>
                    <div @mouseenter="handleShowTooltip($event)">
                      <el-tooltip popper-class="popperCustoms" :visible-arrow="false" :disabled="showTooltip"  placement="bottom" class="single_hide" effect="light">
                        <div class=" color3 single_hide" style="color: #333;max-width:232px">{{ YJinfo.address}}</div>
                        <div slot="content"  style="color: #666;">{{ YJinfo.address}}</div>
                      </el-tooltip>
                    </div>
                    <span
                      @click="showMap"
                      style="marginLeft:10px;cursor:pointer;width:30px;height:16px"
                      v-if="YJinfo.longitude && YJinfo.latitude"
                    >
                      <img src="@/assets/public/map.jpg" alt />
                    </span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="item_text single_hide" style="display:flex">
                    <span class="color6"><img src="@/assets/TeamOfferDetail/lxr.png">联系人：</span>
                    <div @mouseenter="handleShowTooltip($event)">
                      <el-tooltip popper-class="popperCustoms" :visible-arrow="false" :disabled="showTooltip"  placement="bottom" class="single_hide" effect="light">
                        <div class=" color3 single_hide" style="color: #333;max-width:235px">{{ YJinfo.contact |formatContactName}}</div>
                        <div slot="content"  style="color: #666;">{{YJinfo.contact |formatContactName}}</div>
                      </el-tooltip>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="24" class="itemRow">
                <el-col :span="8">
                  <div class="item_text single_hide">
                    <div class="color6" style="display:inline-block;line-height:25px">
                      <img src="@/assets/TeamOfferDetail/lxdh.png">联系电话：
                      <div style="display:inline-block;line-height:25px" class="color3" v-if="showpNumber">{{ YJinfo.contactPhone }}</div>
                      <div style="display:inline-block;line-height:25px" class="color3" v-else>{{ ShowPhone(YJinfo.contactPhone) }}</div>
                      <div
                        style="color:#0286DF;display:inline-block;cursor: pointer;line-height:25px;margin-left:10px"
                        v-if="!showpNumber"
                        @click="ShowPhoneNumber"
                      >
                        查看完整号码
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="16">
                  <div class="item_text single_hide" style="display:flex;margin-bottom:0px;padding-bottom:0px">
                    <span class="color6"><img src="@/assets/TeamOfferDetail/bjfa.png">报价方案：</span>
                    <div v-for="(item,index) in YJinfo.schemeList" :key="index">
                      <div class="bjCase color3" v-if="item.unitPrice">
                        <span style="color:#0286df" >
                          <span>{{item.name}}:</span>
                          <span>{{item.unitPrice}}元</span>
                          <span>/{{item.unit}}</span>
                        </span> 
                      </div>
                    </div>
                  </div>
                </el-col>             
              </el-row>
              <div class="left-footer">
                <btns :item="YJinfo" :type="5" @end="getYJDetail"></btns>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 报价详情 -->
      <div class="offerDetail_tab">
        <el-tabs v-model="activename" @tab-click="handleClick" id="pane">
          <el-tab-pane label="报价详情" activeIndex="0">
            <div class="detailText"  style="line-height: 20px;">
              <!-- 报价方案 -->
              <div>
                <div class="color6" style="margin-bottom:10px">报价方案：</div>
                <el-table
                :data="YJinfo.schemeList"
                :header-cell-style="setColumnDataColor"
                :cell-style="setCellStyle"
                style="width: 100%;"
              >
                <el-table-column
                  align="left"
                  prop="name"
                  label="报价方案"
                  width="500px"
                ></el-table-column>
                <el-table-column
                  align="left"
                  prop="unit"
                  label="计量单位"
                  width="400px"
                ></el-table-column>
                <el-table-column
                  align="left"
                  prop="unitPrice"
                  label="单价(元)"
                >
                </el-table-column>
              </el-table>
              </div>
              <div class="detail-item">
              <span class="item-name">报价详情：</span>
              <span class="item-value">{{ YJinfo.principle }}</span>
              </div>
              <div v-if="YJinfo.customFieldList && YJinfo.customFieldList.length">
                <el-col :span="24" class="detail-item" v-for="(field,index) in YJinfo.customFieldList" :key="index">
                  <span class="item-name">{{ field.title }}：</span>
                  <span class="item-value" style="white-space: pre-line">{{ field.value }}</span>
                </el-col>
              </div>
              <el-col :span="24" class="detail-item" style="display: flex;margin-top: 10px;" v-if="YJinfo.fileList && YJinfo.fileList.length">
                <span class="c666 item-name" style="margin-top:10px">附件：</span>
                <span style="display:flex;flex-wrap: wrap">
                    <div v-for="(file,index) in YJinfo.fileList" :key="index" class="file-item">
                      <div class="file-item-container">
                          <img :src="fileIcon[file.name.split('.').pop().toLowerCase()]" alt="" class="file-icon">
                          <div class="file-info">
                            <div class="file-name">
                              <div class="fore">{{ file.name.slice(0, file.name.lastIndexOf('.')) }}</div>
                              <div class="back">.{{ file.name.split('.').pop() }}</div>
                            </div>
                            <div class="file-other">
                              <span class="file-size">{{ formatFileSize(file.size) }}</span>
                              <span class="file-download" @click="$previewFile(file.fileUrl)">预览</span>
                            </div>
                          </div>
                        </div>
                      </div>
                  </span>
              </el-col>
            </div>
            <BaseEmptyData isDetail v-if="!YJinfo.principle && !loading"></BaseEmptyData>
          </el-tab-pane>
          <!-- 班组简介 -->
          <el-tab-pane label="班组简介" v-if="YJinfo.workTypeDescription||YJinfo.conditions||(YJinfo.teamExplainVo&&YJinfo.teamExplainVo.threeLevelWorkTypeName)||YJinfo.workload||(YJinfo.teamExplainWorkArea&&YJinfo.teamExplainWorkArea.length)||(YJinfo.materialList && YJinfo.materialList.length)||(YJinfo.equipmentList && YJinfo.equipmentList.length)||(YJinfo.teamExplainFieldList && YJinfo.teamExplainFieldList.length)" activeIndex="1" >
            <teamIntroduction :data="YJinfo"></teamIntroduction>
          </el-tab-pane>
          <!-- 工程业绩 -->
          <el-tab-pane  v-if="YJinfo.teamName&&YJinfo.teamNo&&gcyjData&&gcyjData.length"  label="工程业绩" activeIndex="2">
            <el-table
              :data="gcyjData"
              :header-cell-style="setColumnDataColor"
              :cell-style="setCellStyle"
              style="width: 100%"
            >
              <el-table-column  label="项目名称" prop="projectName" show-overflow-tooltip width="170"></el-table-column>
              <el-table-column  label="施工地点" prop="address" show-overflow-tooltip width="170"></el-table-column>
              <el-table-column  label="开工/竣工" prop="startTime" width="230">
                <template slot-scope="scope">
                  <span>{{formatDate(scope.row.startTime)}}-{{ scope.row.endTime==0?"正在建设":formatDate(scope.row.endTime) }}</span>
                </template>
              </el-table-column>
              <el-table-column  label="项目描述" prop="projectDescribe" show-overflow-tooltip width="300"></el-table-column>
              <el-table-column  label="施工内容" prop="construction" show-overflow-tooltip></el-table-column>
            </el-table>
            <Pagination :param="gcyjparam" @change="getTeamResultsList" v-if="gcyjData.length!=0" :loadingTrue="loadingTrue"></Pagination>
          </el-tab-pane>
          <!-- 施工图片 -->
          <el-tab-pane v-if="YJinfo.teamName&&YJinfo.teamNo&&CertList&&CertList.length" label="施工图片" activeIndex="3">
            <!-- <team-album :data="YJinfo"></team-album> -->
            <div  v-if="this.CertList.length" style="margin-left:10px">
              <div>
                <el-row :gutter="20">
                  <el-col :span="4.8" v-for="(item, index) in CertList" :key="index" style="padding-left:0px;height:88px">
                    <el-image
                      style="width: 216px; height: 162px"
                      :src="item.url"
                      :preview-src-list="[item.url]"
                    ></el-image>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 相关推荐 -->
      <div class="recommendList">
        <div class="title">
          <div class="name">相关报价推荐</div>
          <div class="more" @click="More">
            查看更多
            <img src="@/assets/teamIcon/more.png" alt="" />
          </div>
        </div>

        <!-- 列表 -->
        <div class="table" v-loading="loadingTrue">
          <div style="padding: 0px 20px 20px" v-if="teamList.records.length">
            <el-row :gutter="20" v-if="teamList.records.length">
              <el-col
                v-for="(item, index) in teamList.records"
                :span="12"
                :key="index"
              >
                <card :item="item" :type="5"></card>
              </el-col>
            </el-row>
          </div>
          <div
            v-if="!teamList.records.length && !loadingTrue"
            style="width: 1200px; margin: 0 auto"
          >
            <BaseEmptyData isDetail></BaseEmptyData>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      center
      title="地图显示"
      :visible.sync="dialogFormVisible"
      width="70%"
      :close-on-click-modal="false"
    >
      <span>
        <i class="el-icon-location-outline"></i>
        所在地区:
        <!-- {{ messageData.provinceName }}
        {{ messageData.cityName ? "/" + messageData.cityName : null }} -->
        <!-- {{ YJinfo.location ? YJinfo.location : "" }} -->
        {{ YJinfo.address ? "" + YJinfo.address : "" }}
      </span>
      <mapdetail
        ref="childDataDt"
        :center="mapCenter"
        :position="mapPosition"
        :text="text"
      ></mapdetail>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false">
          关 闭
        </el-button>
      </div>
    </el-dialog>
    <!-- 函询弹框 -->
    <InByLetDialog
      :dialogVisible="inByLetDialogShow"
      :dialogType="1"
      @closeDialog="closeinDialog"
      @confirmDialog="confirminDialog"
    ></InByLetDialog>
  </div>
</template>

<script>
import axios from "@/http"
import { formatDate2, formatDate } from "@/filters"
import { apiResignAll } from "@/api/apiResignAll"
import { apiTeamDetail } from '@/api/apiTeamDetail'
import { setColumnDataColor, setCellStyle } from '@/views/Home/components/style.js'
import localStorage from "@/storage/localStorage"
import cookie from "@/storage/cookies"
import { checkDataStatus } from "@/utils/checkDataStatus"
import '@/utils/previewFile'
const ERR_OK = 200
export default {
  name: "IndividualTeamOfferDetail",
  props: {
    item: Object,
    type: {
      type: [Number, String] // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
    }
  },
  data() {
    return {
      setColumnDataColor,
      setCellStyle,
      showTooltip:false,
      fileIcon: {
        jpg: require("@/assets/fileIcon/image.png"),
        jpeg: require("@/assets/fileIcon/image.png"),
        png: require("@/assets/fileIcon/image.png"),
        pdf: require("@/assets/fileIcon/pdf.png"),
        zip: require("@/assets/fileIcon/zip.png"),
        rar: require("@/assets/fileIcon/zip.png"),
        doc: require("@/assets/fileIcon/word.png"),
        docx: require("@/assets/fileIcon/word.png"),
        xlsx: require("@/assets/fileIcon/xls.png"),
        xls: require("@/assets/fileIcon/xls.png")
      },
      state: 1,
      loading: false,
      activename: "0",
      materialList: [],
      equipmentList: [],
      param: {
        hasMore: false,
        no: "",
        provinceNo: "",
        page: 1,
        limit: 6
      },
      showFoldIcon: false, // 收起
      showMoreIcon: false, // 更多
      teamList: {
        records: []
      },
      /** @name 工队no和报价no */
      userNos: {},
      teamInfo: {},
      pNo: "",

      /** @name 业绩详情 */
      YJinfo: {
        categoryName:""
      },
      inByLetDialogShow: false,
      dialogFormVisible: false,
      mapCenter: [],
      mapPosition: [],
      teamSizeOption: [],
      userNo: "",
      companyNo: "",
      // markName:'',
      text: {
        text: "",
        offset: [0, -50]
      },

      ShowMoreText: true,
      isHtml: false,
      showpNumber: false,
      // 当前标志
      InfoNo: null,
      // 主题信息
      UserInfo: {},
      // 详情信息
      messageData: {
      },

      phone: "",
      title: {
        name: "",
        updateTime: null
      },

      IsPerson: true,
      constructionTeamData: {},
      teamTypeData: [],
      teamSkillsData: [],
      rollScroll: false,
      VideoParam: {
        page: 1,
        limit: 10
      },

      offernoTextData: false,
      offerParam: {
        page: 1,
        limit: 10,
        companyNo: "",
        userNo: ""
      },

      loadingTrue: false,
      noTextData: false,
      performanceParam: {
        page: 1,
        limit: 10,
        companyNo: "",
        userNo: ""
      },
      // 是否关注
      isAttention: false,
      // 防止重复提交
      isRepeatSubmit: false,
      gcyjData: [],
      gcyjparam: {
        page: 1,
        limit: 20,
        teamNo: '',
        companyNo: '',
        userNo: '',
        total: 0
      },
      //相册
      CertList: [],
    }
  },
  computed: {
    isLogin: function () {
      return this.$store.state.token
    }
  },
  components: {
    // LeaseList,
    InByLetDialog: () => import("@/components/public/InquiryLetterDialog"), // 函询弹框
    btns: () => import("@/components/details/btns"), // 按钮组
    mapdetail: () => import("@/components/public/components/mapDetail"),
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"),
    card: () => import("@/components/card/cardVolunteerTeamOffer.vue"),
    EmptyData: () => import("@/components/public/UI/EmptyData"), // 数据被删除/下架显示的缺省图
    teamIntroduction:()=>import("@/views/VolunteerTeamOffer/comppnents/teamIntroduction.vue"), // 班组简介
    Pagination: () => import('@/views/Construction/components/Pagination'), // 分页

  },

  created() {},
  mounted() {
    this.userNos = this.$route.query.userNo ? this.$route.query.userNo : ""
    this.pNo = this.$route.query.pNo ? this.$route.query.pNo : ""
    if (cookie.cookieRead("token")) {
      // this.userFocus();
    }
    // this.TeamInfoDetail()
    this.getYJDetail()
    this.teamInfofindPriceList()
  },
  methods: {
    //处理时间
    formatDate(date){
      return moment(date).format('YYYY/MM/DD')
    },
    //获取工程业绩
    async getTeamResultsList (teamNo) {
      this.gcyjparam.teamNo = teamNo
      let res = await apiTeamDetail.getTeamResultsList(this.gcyjparam)
      if (res.data.code === 200) {
        this.gcyjData = res.data.data.records
        this.gcyjparam.total = res.data.data.total
      } 
    },
    // 获取相册
    async getfindAlbumByTeamNo(teamNo) {
      let res = await apiTeamDetail.GetTeamPhoto(teamNo)
      if(res.data.code === 200){
        this.CertList = res.data.data
      }
    },
    //内容超出时,hover显示所有文本信息
    handleShowTooltip(event){
      let cell = event.target.querySelector('.el-tooltip');
      this.showTooltip = cell.scrollWidth === cell.offsetWidth;
    },
         /**
     * 格式化页面显示的文件大小
     * @param fileSize 文件大小
     */
     formatFileSize(fileSize = 0) {
      fileSize = Number(fileSize)
      if (fileSize /1024 > 10) {
        return `${(fileSize /1024).toFixed(2)}M`
      } else {
        return `${Math.ceil(fileSize)}kb`
      }
    },
    handleClick(tab) {},
    // /** @name 跳转店铺 */
    // JumpShop() {
    //   let routeUrlU =
    //     process.env.VUE_APP_MATERIALSURL +
    //     "/TeamPersonal/" +
    //     "?userNo=" +
    //     this.YJinfo.userNo +
    //     "&teamno=" +
    //     this.YJinfo.no +
    //     "&type=0"
    //   window.open(routeUrlU, "_blank")
    // },
    // /** @name 加载更多 */
    // loadingMore() {
    //   if (this.param.hasMore) {
    //     this.param.page++
    //     this.teamInfofindPriceList()
    //   } else {
    //     this.$message.warning("没有更多数据了!")
    //   }
    // },
    /** @name 获取相关推荐列表数据 */
    async teamInfofindPriceList() {
      try {
        this.loadingTrue = true
        let isFirst = this.param.page === 1
        let cookieArea = cookie.cookieRead("area")
        let area = cookieArea ? JSON.parse(cookieArea) : null
        this.param.provinceNo = area.id
        this.param.no = this.$route.query.pNo
        let res = await apiResignAll.getrecommendList(this.param)
        if (res.data.code === 200) {
          this.teamList.records = res.data.data.records
          this.param.hasMore = res.data.data.pageNum !== res.data.data.totalPage
          this.loadingTrue = false
        }
        if (this.teamList.records.length < 6) {
          this.showMoreIcon = false
        } else {
          this.showMoreIcon = true
        }
        isFirst ? (this.showFoldIcon = false) : (this.showFoldIcon = true)
      } catch (err) {
        this.loadingTrue = false
      }
    },
    formatDate,
    /** @name 邀请 */
    async invitation() {
      if (!(await this.validData())) {
        return
      }
      this.$message.error("请先认证企业!")
    },
    /** @name 加盟 */
    async join() {
      if (!(await this.validData())) {
        return
      }
      this.$message.error("请先认证企业!")
    },
    /** @name 函询按钮点击方法 */
    async inByLetDialogClick() {
      if (!(await this.validData())) {
        return
      }
      if (this.$store.state.loginType) {
        this.inByLetDialogShow = true
      } else {
        this.loginIndex()
      }
    },
    /** @name 函询关闭 */
    closeinDialog(val) {
      this.inByLetDialogShow = val
    },
    /** @name 函询提交 */
    async confirminDialog(obj) {
      obj.markName = this.item.typeWorkName
      obj.title = "【工种报价】" + `${this.item.categoryName.split("-").length>=3 ? this.item.categoryName.split("-")[2] : this.item.categoryName.split("-")[ this.item.categoryName.split("-").length-1]}`
      obj.markType = 5
      obj.markCreateNo = this.item.userNo
      obj.markId = this.item.no
      obj.companyNo = this.item.companyNo ? this.item.companyNo : ""
      let res = await apiResignAll.getaddEnquire(obj)
      if (res.data.code === 200) {
        this.$message.success("提交成功")
        this.inByLetDialogShow = false
      } else {
        this.$message.error("提交失败")
      }
    },
    // 点击查看地图
    showMap() {
      this.dialogFormVisible = true
    },
    /** @name 过滤主营业务数据 */
    ChangeStringBus(data) {
      const array = []
      if (data.businessScopes && data.businessScopes.length > 0) {
        data.businessScopes.map(item => {
          const secArray = []
          if (item.firstCategoryName) {
            secArray.push(item.firstCategoryName)
          }
          if (item.secondCategoryName) {
            secArray.push(item.secondCategoryName)
          }
          if (item.thirdCategoryName) {
            secArray.push(item.thirdCategoryName)
          }
          if (item.fourCategoryName) {
            secArray.push(item.fourCategoryName)
          }
          if (item.fifthCategoryName) {
            secArray.push(item.fifthCategoryName)
          }
          if (item.sixthCategoryName) {
            secArray.push(item.sixthCategoryName)
          }
          array.push(secArray.join("/"))
        })
      }
      //
      return array.join("；")
    },
    GoDetila(id) {
      this.$router.push({
        path: `/teamDetails/${id}`
      })
      location.reload()
    },
    // 地址
    ChangeAddress(data) {
      var array = []
      if (data) {
        const objArray = JSON.parse(data) ? JSON.parse(data) : []
        //
        objArray.map(item => {
          array.push(item.name)
        })
      }
      const string = array.join(",")
      return string
    },
    /** @name 获取业绩详情 */
    async getYJDetail() {
      this.loading = true
      let data = await axios.get("/teamPrice/priceDetail", { no: this.pNo })
      this.YJinfo = data.data.data
      if(this.YJinfo.teamNo){
        this.getTeamResultsList(this.YJinfo.teamNo)
        this.getfindAlbumByTeamNo(this.YJinfo.teamNo)
      }
      if(this.YJinfo.schemeList&&!this.YJinfo.schemeList.length){
          if(this.YJinfo.hasMaterial==0){
              this.YJinfo.hasMaterial='包含辅材'
          }else if(this.YJinfo.hasMaterial==1){
              this.YJinfo.hasMaterial='包含机械设备'
          }else if(this.YJinfo.hasMaterial==2){
              this.YJinfo.hasMaterial='包含辅材和机械设备'
          }else if(this.YJinfo.hasMaterial==3){
              this.YJinfo.hasMaterial='不包含辅材和机械设备'
          }
          this.YJinfo.schemeList=[{name:`${this.YJinfo.hasMaterial}`,unit:`${this.YJinfo.unit}`,unitPrice:`${this.YJinfo.price}`}]
      }else if(this.YJinfo.schemeList&&this.YJinfo.schemeList.length){
        this.YJinfo.schemeList=this.YJinfo.schemeList.filter(v=>v.unitPrice)
      }
      this.loading = false
      this.materialList = this.YJinfo.materialList
      this.equipmentList = this.YJinfo.equipmentList

      let temp = [Number(this.YJinfo.longitude), Number(this.YJinfo.latitude)]
      this.mapCenter = temp
      this.mapPosition.push(Number(temp[0]))
      this.mapPosition.push(Number(temp[1]))
    },
    // 查看更多
    More() {
      this.$store.commit("SET_INDEXKEY", 1)
      localStorage.set("indexKey", 1)
      this.$router.push("/volunteerTeamOffer")
    },
    // 联系号码
    ShowPhone(phone) {
      if (phone && phone.length === 11) {
        const number = `${phone.slice(0, 3)}****${phone.slice(7, 11)}`
        return number
      }
    },

    /** @name 在线咨询 */
    async OnlineConsulting() {
      if (!(await this.validData())) {
        return
      }
      if (this.$store.state.loginType) {
        if (this.messageData.imId) {
          axios
            .get(
              process.env.VUE_APP_APITEAM +
                "/consultation?id=" +
                this.messageData.imId
            )
            .then(res => {
              if (res.data.code === ERR_OK) {
                this.$store.commit("SET_ISOPEN", true)
                this.$store.commit("SETTOUSER", res.data.data.imAccount)
              } else {
                this.$message.error(res.data.msg)
              }
            })
        } else {
          this.$message.error("该信息为个人用户发布，当前无法交流")
        }
      } else {
        this.loginIndex()
      }
    },
    //  查看联系方式
    ShowPhoneNumber() {
      if (this.$store.state.loginType) {
        this.showpNumber = true
      } else {
        this.loginIndex()
      }
    },
    loginIndex() {
      let data = {
        callBack: function () {
          this.$store.dispatch("setUser")
          this.pushThis()
        }.bind(this)
      }
      this.$_login(data)
    },
    formatDate2,

    tel(telNum) {
      if (telNum) {
        let ary = telNum.split("")
        ary.splice(3, 4, "****")
        return ary.join("")
      }
      return ""
    },

    changeRollScroll(bol) {
      this.rollScroll = bol
    },

    menu() {},
    getShowTab() {},
    // 获取是否关注
    // userFocus() {
    //   let params = {
    //     no: this.$route.query.teamNo,
    //     type: 5,
    //   };
    //   apiHelp.userFocus(params).then((res) => {
    //     if (res.data && res.data.code === 200) {
    //       this.isAttention = res.data.data;
    //     }
    //   });
    // },

    /**
     * @name 点击关注
     * @type 工队1 工程2 工人3 */
    clickAttention(state) {
      let token = this.$store.state.token
      if (!token) {
        let data = {
          callBack: function () {
            this.$store.dispatch("setUser")
          }.bind(this)
        }
        this.$_login(data)
      } else {
        let no = this.$route.query.teamNo
        let type = 1
        if (this.isRepeatSubmit) return
        this.isRepeatSubmit = true
        apiResignAll
          .addAttention(no, type)
          .then(res => {
            if (res.data.code === 200) {
              this.isAttention = state
              if (state) {
                this.$message.success("关注成功")
              } else {
                this.$message.success("取消关注成功")
              }
            }
          })
          .finally(() => {
            this.isRepeatSubmit = false
          })
      }
    },
    /**
     * 调用工具方法检测数据有效性
     */
    async validData() {
      const state = await checkDataStatus(1, this.$route.query.teamNo)
      if (!state) {
        this.$message.error("系统异常，请稍后再试")
        return false
      }
      this.state = state
      return this.state == 1
    },
    handleBack() {
      const referrer = document.referrer
      if (
        referrer.includes("TeamOfferDetail") ||
        referrer.includes("IndividualTeamOfferDetail")
      ) {
        this.$router.replace("/volunteerTeamOffer")
      } else {
        window.location.href = referrer
      }
    },
    getList() {
      this.teamInfofindPriceList()
    }
  },
  provide() {
    return {
      cardListCom: this
    }
  }
  // watch: {
  //   isLogin: {
  //     handler: function (newVal, oldVal) {
  //       newVal && this.userFocus();
  //     },
  //   },
  // },
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";
/deep/.el-tabs__item:focus.is-active.is-focus:not(:active){
  box-shadow: none;
}
/deep/.el-tabs__active-bar{
  width: 64px!important;
}
/deep/.el-tabs__item{
  padding: 0 25px!important;
}
/deep/.el-table th ,/deep/.el-table td{
  height: 44px!important;
  padding: 0 !important;
}
.bgdf {
  background: #dfe4ea;
}

.talents {
  width: 100%;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  &_details {
    width: 1200px;
    background: #f5f5f5;
    &_content {
      width: 1200px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      &_left {
        width: 1200px;
        &_titleBox {
          width: 1200px;
          margin: 0 auto;
          box-sizing: border-box;
          background-color: #ffffff;
          padding: 20px 20px 0 20px;
          border-radius: 3px;
          position: relative;
          border-bottom: 1px solid #e4e7ed;
          display: flex;
          .pic {
            width: 120px;
            height: 120px;
            border: 1px solid #e4e7ed;
            margin-right: 10px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .left_box {
            width: 100%;
            .itemRow {
              font-size: 14px;
              color: #666666;
              display: flex;
              align-items: center;
              .item_text {
                // padding: 5px 0;
                line-height: 25px;
                margin-bottom: 20px;
                img {
                  width: 24px;
                  height: 24px;
                  margin-right: 10px;
                  vertical-align: middle;
                  margin-top: -4px;
                }
                .bjCase{
                  height: 20px;
                  line-height: 20px;
                  background: rgba(2, 134, 223,0.1);
                  margin-right:10px ;
                  border-radius: 2px;
                  color:#0286DF ;
                  padding: 0px 5px;
                  box-sizing: border-box;
                  font-size: 12px;
                  margin-top: 3px;
                }
              }
              .single_hide {
                // 单行隐藏
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .color6 {
                color: #666666;
              }
              .color3 {
                color: #333333;
              }
            }
            .imgIcon {
              text-align: left;
              line-height: 30px;
              img {
                display: inline-block;
                margin-right: 15px;
              }
            }
            .left-footer {
              display: flex;
              justify-content: center;
              width: 100%;
              .btn-item {
                padding: 10px 20px;
                margin-right: 15px;
                font-size: 14px;
                border: 1px solid #b79255;
                color: #b79255;
                background: #fff;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                &:hover {
                  color: #f7ab01;
                  border: 1px solid #f7ab01;
                }
                img {
                  display: inline-block;
                  margin-right: 5px;
                  width: 18px;
                  height: 18px;
                }
              }
            }
          }
          .title {
            margin-bottom: 10px;
            display: flex;
            align-items: flex-start;
            .text {
              font-size: 24px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(0, 0, 0, 1);
              line-height: 36px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              max-width: 800px;
              -webkit-box-orient: vertical;
            }
            .show {
              width: 100px;
              width: 140px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(150, 150, 150, 1);
              line-height: 30px;
            }
            .icon {
              border-radius: 5px;
              display: inline-block;
              padding: 10px 20px;
              background: #0099ff;
              color: white;
              padding: 5px 9px;
              font-size: 14px;
              margin-left: 15px;
            }
          }
          .item {
            font-size: 14px;
            display: flex;
            align-items: flex-start;
            line-height: 30px;
            .flex-item {
              display: flex;
              flex: 1;
            }
            span.showText {
              color: #0099ff;
              margin-left: 14px;
              // text-decoration: underline;
              cursor: pointer;
            }
            & > div {
              margin-right: 20px;
              
              span {
                color: #666;
                &:nth-child(2) {
                  color: #333;
                }
              }
            }
          }
        }
      }
      &_right {
        width: 300px;
        margin-left: 20px;

        .PersonMessage {
          padding: 10px 20px;
          background: white;
          box-shadow: 0 2px 5px #e1e1e1;
          border-bottom: 1px solid #e4e7ed;
          margin-bottom: 10px;

          .name {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            line-height: 36px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .describe {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }

            .text {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }

            .icon {
              display: inline-block;
              background: rgba(2, 134, 223, 1);
              border-radius: 4px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 21px;
              margin-left: 20px;
              padding: 0px 6px;
            }
          }

          .item {
            font-size: 14px;
            line-height: 30px;

            span.showText {
              color: #0099ff;
              margin-left: 14px;
              // text-decoration: underline;
              cursor: pointer;
            }
          }

          .box {
            // margin: 10px 0 20px;
            border: 1px solid #0099ff;
            color: #0099ff;
            width: 80px;
            font-size: 14px;
            // text-align: center;
            padding: 8px 15px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 15px auto;

            img {
              margin-right: 5px;
            }

            cursor: pointer;
          }
        }
      }
    }
    .recommendList {
      background: white;
      margin-top: 10px;
      border: 1px solid #E4E7ED;
      .title {
        font-weight: normal !important;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px 0;
        border-bottom: 1px solid #e4e7ed;
        .name {
         font-size: 16px;
          color: #b79255;
          line-height: 15px;
          height: 15px;
          border-left: 3px solid #b79255;
          padding-left: 10px;
          margin: 10px 0px;
        }
        .more {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          //line-height: 36px;
          cursor: pointer;
          display: flex;
          align-items: center;
          img {
            margin-left: 5px;
            width: 16px;
            height: 16px;
          }
        }
      }
      /deep/ .empty-data .nodata .message {
        line-height: 1;
      }
    }
    .dataList {
      background: white;
      margin-top: 10px;
      > .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .name {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #b79255;
          line-height: 30px;
          border-left: 3px solid #b79255;
          padding-left: 10px;
        }
        .more {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 36px;
          cursor: pointer;
        }
      }
      .itemList {
        padding: 10px 0px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        .item {
          width: 273px;
          margin-right: 20px;
          border: 1px solid rgba(228, 230, 237, 1);
          font-size: 12px;
          color: #999;
          line-height: 30px;
          margin-bottom: 20px;
          &:nth-child(4n) {
            margin-right: 0px;
          }
          .top {
            padding: 10px 8px;
            // height: 90px;
            max-height: 90px;
            background: rgba(245, 247, 250, 1);
            .title {
              color: #000;
              font-size: 14px;
              font-weight: 300;
              cursor: pointer;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
          .bottom {
            padding: 10px 8px 0 8px;
            height: 90px;
            height: 70px;
            .type {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .business {
              line-height: 30px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          span {
            color: #333;
          }
        }
      }
      .noList {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 275px;
      }
    }
  }
}
.detail-item {
    display: flex;
    margin-top: 20px;
    .item-name {
      font-size: 14px;
      flex-shrink: 0;
      color: var(--FC6);
    }
    .item-value {
      font-size: 14px;
      color: var(--FC3);
    }
  }
  .file-item {
    margin-right: 10px;
    margin-top: 10px;
    .file-item-container {
      box-sizing: border-box;
      width: 236px;
      display: flex;
      padding: 10px 20px 10px 10px;
      background-color: #FAFAFA;
      font-size: 14px;
      border-radius: 4px;
      .file-icon {
        width: 33px;
        height: 40px;
      }
      .file-info {
        flex: 1;
        padding-left: 10px;
        line-height: 1.2;
        .file-name {
          margin-bottom: 10px;
          display: flex;
          color: var(--FC3);
          .fore {
            max-width: 148px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }
          .back{
            flex-shrink: 0;
          }
        }
        .file-other {
          display: flex;
          justify-content: space-between;
          .file-size {
            color: var(--FC9);
          }
          .file-download {
            cursor: pointer;
            color: #0286df;
          }
        }
      }

    }
  }
.offerDetail_tab {
  margin-top: 10px;
  border: 1px solid #e4e7ed;
  background-color: #fff;
/deep/ .el-table{
  border: solid 1px #E4E7ED;
  border-bottom: none;
}
  /deep/ .el-tabs__item {
    font-size: 16px;
    position: relative;
    &:not(:last-child):before {
      content: "";
      display: inline-block;
      height: 24px;
      border-left: 1px solid #e4e7ed;
      position: absolute;
      right: 0;
      top: 8px;
    }
  }
  /deep/ .el-tabs__item.is-active {
    color: #b79255;
  }
  /deep/ .el-tabs__item:hover {
    color: #b79255;
  }
  /deep/ .el-tabs {
    .el-tabs__header {
      margin: 0;
      height: 42px;
      .el-tabs__nav-wrap {
        padding: 0;
      }
    }
    .el-tabs__active-bar {
      background-color: #b79255;
    }
    .el-tabs__content {
      padding: 20px;
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }
  .detailText {
    color: #333333;
    font-size: 14px;
  }
}
</style>
<style lang="scss" rel="stylesheet/scss">
// 污染全局？？
.changeTootip {
  border: 1px solid #767676 !important;
  padding: 4px !important;
  font-size: 12px !important;
  font-family: Microsoft YaHei;
  // font-weight: 300 !important;
  color: rgba(102, 102, 102, 1) !important;
  border-radius: 2px !important;
  max-width: 1200px !important;
}
</style>
